
import { useContext } from 'react'
import { ThemeContext } from '../context'

export function useLightTheme() {
  const context = useContext(ThemeContext)
  return context.light
}